import "#/shared/api/api-host-global.js";
import "../shared/codeload.js";
import "./utilities/publishing_domain.js";
import "./ajax.js";
import "./container.js";
import "./events.js";

window.Sparkle ??= {};

window.Sparkle.currentPublishingDomain =
  window.Sparkle.currentPublishingDomain ||
  Sparkle.Embed.Utilities.detectPublishingDomain() ||
  window.SparkleConfig?.publishingDomains?.default;

if (window.SparkleConfig?.theme) {
  const theme = window.SparkleConfig.theme;

  window.Sparkle.currentThemeName =
    window.Sparkle.currentThemeName ||
    theme.byPublishingDomain?.[window.Sparkle.currentPublishingDomain] ||
    theme.default;
}
